import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";

//Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";
//redux
import { useDispatch } from "react-redux";
import { addFAQs } from "../../../../Redux/Slices/contentManagementSlice";

const AddFAQs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleValidation = () =>{
    let validationErrors = {};
    
    const questionErrors = validateInput("faqQuestion", question);
    if (questionErrors.faqQuestion) {
      validationErrors.question = questionErrors.faqQuestion;
    }
    const answerErrors = validateInput("faqAnswer", answer);
    if (answerErrors.faqAnswer) {
      validationErrors.answer = answerErrors.faqAnswer;
    }
    setErrors(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
    // Handle form submission logic here
    const data = {
      question,answer
    }

    const addFAQCB = (value) => {
     setIsSuccess(true)
    }
    dispatch(
      addFAQs({ 
        data:data,
        callBack:addFAQCB
      })
    ) 
  }
  };

  return (
    <MainLayout pageName={"Content Management"}>
      {/* SuccessCard - Conditionally render */}
      {isSuccess && (
        <SuccessCard 
        title="Added Successfully"
        subTitle="FAQ Details Added Successfully."
        onClose={() => setIsSuccess(false)} // Close the SuccessCard
        onGoBack={() => navigate(-1)} // Navigate back
        buttonText="Back to Contents"
      />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to FAQ List</p>
      </div>
      <form className="AddFAQContainer" onSubmit={handleSubmit}>
        {/* Header */}
        <div className="AddFAQContainerHeader">
          <h2>Add FAQ</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6", marginBottom:'45px' }} />
        <div className="AddFAQTextContainer">
          <p>Question</p>
          <div className="AddFAQInputBoxContainer">
            <InputBox
              inputStyle={{
                border: "1px solid #B2BEC3",
                padding: "1px 2vh 1px 2vh",
                height: "7vh",
                boxShadow:'none',
                color: "black"
              }}
              name="videoLink"
              value={question}
              onChange={(e) => {setQuestion(e.target.value);
                setErrors({
                  ...errors,
                  question:''
                })
              }}
            />
            {errors.question && <ErrorMessage message={errors.question} />}
          </div>
        </div>
        <div className="AddFAQTextContainer">
          <p>Answer</p>
          <div className="AddFAQInputBoxContainer">
            <textarea
              value={answer}
              onChange={(e) => {setAnswer(e.target.value);
                setErrors({
                  ...errors,
                  answer:''
                })
              }}
              rows="5"
              placeholder="Enter here"
              className="textAreaInput"
            />
            {errors.answer && <ErrorMessage message={errors.answer} />}
          </div>
        </div>
        <div className="addFAQButtons">
          <div className="addFAQButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addFAQButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Save"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default AddFAQs;
